<template>
  <div>
    <el-badge :is-dot="isFilterApplied">
      <el-button class="filter-new" type="default" title="Фильтр" size="medium" @click="visible = true">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="16" viewBox="0 0 17 16">
          <path d="M15.1798 0H1.75861C1.4179 0.000268305 1.08459 0.0994258 0.799131 0.285438C0.513674 0.471451 0.288345 0.736321 0.150492 1.0479C0.0126389 1.35948 -0.0318118 1.70438 0.0225349 2.04073C0.0768815 2.37708 0.227689 2.69043 0.456654 2.94274L6.27312 9.3396V15.3725C6.27317 15.4905 6.30646 15.606 6.36916 15.7059C6.43186 15.8058 6.52144 15.8859 6.62763 15.9372C6.7125 15.9791 6.80595 16.0006 6.90057 16C7.04318 15.9999 7.18149 15.9512 7.29273 15.8619L8.4692 14.9208L10.43 13.3521C10.5034 13.2934 10.5626 13.2189 10.6033 13.1342C10.644 13.0495 10.6652 12.9567 10.6653 12.8627V9.3396L16.4817 2.94274C16.7107 2.69043 16.8615 2.37708 16.9159 2.04073C16.9702 1.70438 16.9258 1.35948 16.7879 1.0479C16.65 0.736321 16.4247 0.471451 16.1393 0.285438C15.8538 0.0994258 15.5205 0.000268305 15.1798 0Z"/>
        </svg>
        <span v-if="!hideText" class="filter-text">Фильтр</span>
      </el-button>
    </el-badge>

    <el-dialog :model-value="visible" :before-close="handleClose" title="Фильтр" :width="width">
      <div class="body agrostream-form filter">
        <slot/>
      </div>
      <div class="footer">
        <el-button size="medium" @click="handleClose">
          Сбросить
        </el-button>
        <el-button type="primary" size="medium" @click="applyFilter">
          Применить
        </el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {isFilterApplied} from "@/services/baseServices";

export default {
  name: "BaseFilter",
  props: {
    "filterModel": {
      type: Object,
      default: () => {},
    },
    "exceptions": {
      type: Array,
      default: () => [],
    },
    "hideText": {
      type: Boolean,
      default: false,
    },
    "width": {
      type: String,
      default: '380px'
    }
  },
  data() {
    return {
      visible: false
    }
  },
  computed: {
    isFilterApplied() {
      return isFilterApplied(this.filterModel, this.exceptions)
    },
  },
  methods: {
    applyFilter() {
      this.$emit("apply")
      this.visible = false
    },
    handleClose() {
      this.$emit("close")
      this.visible = false
    },
  }
}
</script>

<style scoped lang="scss">
  .body {
    display: block;
    margin-bottom: 30px;
  }
  .footer {
    display: flex;
    justify-content: space-between;
  }
  .filter-new {
    svg {
      fill: #8F9BB3;
    }
    &:hover {
      svg {
        fill: #49af69;
      }
    }
  }
</style>
